import { GetServerSideProps } from 'next';
import { useEffect } from 'react';
import { Benefits } from '@src/components/Benefits';
import { Hero } from '@src/components/Hero';
import { Layout } from '@src/components/Layout';
import { ClinicDistance } from '@src/pages/api/distances.page';
import { useAppStore } from '@src/store';
import serverSidePropsWellnow from '@src/utils/serverSidePropsWellnow';
const HomePage = ({
  urgentCareUrl,
  config
}) => {
  const {
    setUrgentCareCentersLink,
    setFeatureFlags,
    setDistances
  } = useAppStore();
  useEffect(() => {
    if (urgentCareUrl) {
      setUrgentCareCentersLink(urgentCareUrl);
    }
  }, [urgentCareUrl, setUrgentCareCentersLink]);
  useEffect(() => {
    if (config.featureFlags) {
      setFeatureFlags(config.featureFlags);
    }
  }, [config.featureFlags, setFeatureFlags]);
  useEffect(() => {
    const getLocationDistances = async () => {
      // Fetch distances API data
      try {
        const distancesRes = await fetch(`${process.env.APP_PATH}/api/distances/`);
        const distances: Record<string, ClinicDistance[]> = distancesRes.ok ? await distancesRes.json() : {};
        setDistances(distances);
      } catch (error) {
        console.log('Distances call failure');
        setDistances({});
      }
    };
    getLocationDistances();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Layout data-sentry-element="Layout" data-sentry-component="HomePage" data-sentry-source-file="index.page.tsx">
			<Hero data-sentry-element="Hero" data-sentry-source-file="index.page.tsx" />
			<Benefits data-sentry-element="Benefits" data-sentry-source-file="index.page.tsx" />
		</Layout>;
};
export const getServerSideProps: GetServerSideProps = async ({
  locale,
  preview = false
}) => {
  const {
    props
  } = await serverSidePropsWellnow(locale, preview, 'HOME');
  return {
    props: {
      urgentCareUrl: process.env.NEXT_PUBLIC_WELLNOW_URGENT_CARE_CENTERS,
      ...props
    }
  };
};
export default HomePage;